import {createReducer} from '@reduxjs/toolkit';
import {OperationsSchemaV2} from '~/entities/operations-fiat';
import {operationsRequestRoutine} from '~/redux/finances/financesEffects';

type EndpointCache<Data> =
    | {readonly status: 'initial'; readonly data: undefined}
    | {readonly status: 'trigger'; readonly data: Data | undefined}
    | {readonly status: 'success'; readonly data: Data}
    | {readonly status: 'failure'; readonly data: undefined; readonly error: unknown};

export type FinancialState = EndpointCache<FinancialData>;
export type FinancialData = OperationsSchemaV2;

export const financesReducer = createReducer<FinancialState>({status: 'initial', data: undefined}, builder => {
    builder.addCase(operationsRequestRoutine.success, (_, {payload}): FinancialState => {
        return {
            status: 'success',
            data: {
                providers: payload.providers,
                operations: payload.operations,
                accounts: payload.accounts,
                paymentNetworks: payload.paymentNetworks,
                paymentCards: payload.paymentCards,
                operationsSettings: payload.operationsSettings,
            },
        };
    });
    builder.addCase(operationsRequestRoutine.failure, (_, {payload}) => ({
        status: 'failure',
        data: undefined,
        error: String(payload),
    }));
    builder.addCase(operationsRequestRoutine.request, state => {
        if (state.status === 'success' || state.status === 'trigger') {
            return state;
        }
        return {
            status: 'trigger',
            data: state.data,
        };
    });
});
